import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { ActivatedRoute } from '@angular/router'
import { ConfirmationMessageComponent } from 'src/app/shared/components/confirmation-message/confirmation-message'
import { MatDialog } from '@angular/material/dialog'
import { SharedService } from 'src/app/shared/services/shared.service'

@Component({
	selector: 'app-organization-profile-branches',
	templateUrl: './organization-profile-branches.component.html',
	styleUrls: ['./organization-profile-branches.component.scss'],
})
export class OrganizationProfileBranchesComponent
	implements OnInit, OnChanges, OnDestroy
{
	@Input() organization: any = ''
	selectedBranch!: any
	isSlideChecked: string = ''
	service: any
	inCompleteDataHover: boolean = false
	hoverId!: number | null
	subscription = new Subscription()
	branches = true
	stores = false

	constructor(
		private OrganizationsService: OrganizationsService,
		private routeActivate: ActivatedRoute,
		private dialog: MatDialog,
		private sharedServ: SharedService
	) {}

	ngOnInit(): void {
		this.routeActivate.params.subscribe(({ id }) => {
			this.service = id
		})

		this.selectedBranch = this.organization?.branches[0]
	}
	ngOnChanges(): void {
		this.selectedBranch = this.organization?.branches[0]
	}
	updateStatus(id: number, index: number, event: any, active: boolean) {
		const activeStatus = !active

		this.dialog
			.open(ConfirmationMessageComponent, {
				width: '585px',
				height: '350px',

				data: {
					image: `assets/images/${
						activeStatus == false ? 'block.svg' : 'correct.svg'
					}`,
					notflex: true,

					message: activeStatus
						? 'CONFIRMATION_MESSAGE.ACTIVATION_CONFIRMATION'
						: 'CONFIRMATION_MESSAGE.DEACTIVATION_CONFIRMATION',
					cancelBtn: 'ACTIONS.CANCEL',
					confirmBtn: activeStatus ? 'ACTIONS.ACTIVATE' : 'ACTIONS.DEACTIVATE',
				},
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.subscription.add(
							this.OrganizationsService.activateDeactivateBranch(
								id,
								activeStatus
							).subscribe((res) => {
								this.organization.branches[index].isActive = activeStatus
							})
						)
					} else {
						event.source.checked = !event.source.checked
					}
				},
			})
	}

	// activateDeactivateBranch(id: number, active: boolean, event: any) {
	// 	this.subscription.add(
	// 		this.OrganizationsService.activateDeactivateBranch(id, active).subscribe(
	// 			(res) => {
	// 				return
	// 			},
	// 			(err) => {
	// 				event.source.checked = true
	// 			}
	// 		)
	// 	)
	// }

	changeTitle() {
		this.sharedServ.headerTitle.next(
			`${this.organization.businessName} - ${this.selectedBranch?.name}`
		)
		localStorage.setItem(
			'activeOrganization',
			`${this.organization.businessName} - ${this.selectedBranch?.name}`
		)
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
